<app-menu>
  <div class="desktop">
    <app-voltar class="back" />
    <div class="header">
      <app-titulo text="Associar EPI"></app-titulo>
    </div>
    <form #frenteDeTrabalhoForm="ngForm">
      <app-input
        type="text"
        label="Equipamento"
        name="material"
        [(ngModel)]="form.material"
        [disabled]="true"
      ></app-input>
      <app-input
        type="text"
        label="Área"
        name="area"
        [(ngModel)]="form.area"
        [disabled]="true"
      ></app-input>
      <app-select-check
        label="Pessoa(s)"
        name="pessoa"
        [selectData]="pessoaOptions"
        [(ngModel)]="form.pessoas"
        (ngModelChange)="changeSelect($event)"
        [requiredInput]="true"
      ></app-select-check>
      <div>
        <label *ngIf="form.pessoas.length === 1"
          >Pessoa selecionado ({{ this.form.pessoas.length }})</label
        >
        <label *ngIf="form.pessoas.length > 1"
          >Pessoas selecionados ({{ this.form.pessoas.length }})</label
        >
        <ul class="pessoa-list">
          <li *ngFor="let pessoa of pessoaList">
            {{ pessoa }}
          </li>
        </ul>
      </div>
    </form>
    <app-botao
      text="Associar"
      class="grid-2fr"
      (click)="visibleTermos = true"
      *ngIf="permission === 1"
      [disabled]="validacaoForm() ? false : true"
    ></app-botao>
  </div>
</app-menu>

<app-modal-termos-epi-layout
  [visible]="visibleTermos"
  (termosAceitos)="changeTermos($event)"
/>
<app-loader *ngIf="loader" />
